import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, X } from "lucide-react";

export const CoachNudgeCard = () => {
  const [nudge, setNudge] = useState(null);

  useEffect(() => {
    api.get("/nudges/latest").then((r) => setNudge(r.data.nudge)).catch(() => {});
  }, []);

  if (!nudge) return null;

  const dismiss = async () => {
    await api.post(`/nudges/${nudge.id}/dismiss`);
    setNudge(null);
  };

  return (
    <section className="card mb-8 flex gap-4 fade-up" style={{ borderColor: "#FF0055" }} data-testid="coach-nudge-card">
      <div className="w-10 h-10 flex items-center justify-center shrink-0" style={{ background: "#FF0055" }}>
        <Sparkles size={16} color="white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="eyebrow" style={{ color: "#FF0055" }}>CINDR Coach // Midweek</p>
        <p className="text-sm md:text-base text-zinc-100 mt-2 leading-relaxed" data-testid="coach-nudge-text">{nudge.text}</p>
        {nudge.signals?.length > 0 && (
          <p className="text-[10px] uppercase tracking-widest text-zinc-500 mt-3">
            {nudge.signals.map((s) => s.type).join(" · ")}
          </p>
        )}
      </div>
      <button onClick={dismiss} className="text-zinc-500 hover:text-white transition-colors self-start" aria-label="Dismiss" data-testid="coach-nudge-dismiss">
        <X size={16} />
      </button>
    </section>
  );
};
